<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Valerie Keogh</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">The Dublin Murder Mysteries</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="http://mybook.to/NoSimpleDeath" target="_blank"><i>No Simple Death</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="http://mybook.to/NoObviousCause" target="_blank"><i>No Obvious Cause</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="http://mybook.to/NoPastForgiven" target="_blank"><i>No Past Forgiven</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="http://mybook.to/NoMemoryLost" target="_blank"><i>No Memory Lost</i></a></p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">Psychological thrillers</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><a class="content-external-link" href="https://mybook.to/TheThreeWomen" target="_blank"><i>The Three Women</i></a></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link"><i>The Perfect Life</i></span></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link"><i>The Deadly Truth</i></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-valerie-keogh.vue?7fed13b5